var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8f2fec12-1f49-4ce4-9777-5afb10b16318",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.12 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,18.18v8.82h12l-1.65,12.8h-10.35v32.2H10.79V39.8H0v-12.8H10.79v-10.08C10.79,5.96,17.48,0,27.25,0c4.68,0,8.71,.35,9.87,.51V11.95h-6.78c-5.32,0-6.34,2.53-6.34,6.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkFacebook);
export default __webpack_public_path__ + "static/media/dark - facebook.8e37690779742afc4f0dc344e2795a91.svg";
export { ForwardRef as ReactComponent };